/* eslint-disable */ import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  flex: none;\n  padding: 20px 4px;\n  background-color: ",
        ";\n  /* height: 260px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  /* height: ",
        "px; */\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  /* padding: 16px 0; */\n  color: #000;\n  border-bottom: solid 2px rgba(133, 133, 133, 0.1);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  color: #fff;\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: 5px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Flex, Button, useModal } from "@noahswap/uikit";
import { useTranslation } from "@noahswap/localization";
import NetworkModal from "../../../../../../src/components/Menu/UserMenu/NetworkModal";
import RpcModal from "../../../../../../src/components/Menu/UserMenu/RpcModal";
import LanguageModal from "../../../../../../src/components/Menu/UserMenu/LanguageModal";
import { CogIcon } from "../../Svg";
import IconButton from "../../Button/IconButton";
import { MENU_ENTRY_HEIGHT, socialsMore } from "../config";
import SocialLinks from "./SocialLinks";
var Container = styled.div.withConfig({
    componentId: "sc-d9bb6fae-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.nav.background;
});
var SocialEntry = styled.div.withConfig({
    componentId: "sc-d9bb6fae-1"
})(_templateObject1(), MENU_ENTRY_HEIGHT);
var AddLinks = styled.div.withConfig({
    componentId: "sc-d9bb6fae-2"
})(_templateObject2());
var IconLabel = styled.span.withConfig({
    componentId: "sc-d9bb6fae-3"
})(_templateObject3());
var PanelFooter = function(param) {
    var isPushed = param.isPushed, pushNav = param.pushNav;
    var ref = useTranslation(), _currentLanguage = ref.currentLanguage, langCode = _currentLanguage.code, t = ref.t;
    var jumpHref = "https://noah-finance.gitbook.io/noah/";
    if (langCode === "zh-tw") {
        jumpHref = "https://noah-finance.gitbook.io/noah/v/fan-ti/";
    } else if (langCode === "ko") {
        jumpHref = "https://noah-finance.gitbook.io/noah/v/undefined/";
    }
    var ref1 = _sliced_to_array(useModal(/*#__PURE__*/ _jsx(NetworkModal, {})), 1), onPresentNetworkModal = ref1[0];
    var ref2 = _sliced_to_array(useModal(/*#__PURE__*/ _jsx(RpcModal, {})), 1), onPresentRpcModal = ref2[0];
    var ref3 = _sliced_to_array(useModal(/*#__PURE__*/ _jsx(LanguageModal, {})), 1), onPresentLanguageModal = ref3[0];
    var onClickWalletMenu = function(id) {
        console.log;
        if (id === "Docs") {
            window.open(jumpHref);
            return;
        }
        if (id === "Network") {
            onPresentNetworkModal();
        }
        if (id === "Rpc") {
            onPresentRpcModal();
        }
        if (id === "Language") {
            onPresentLanguageModal();
        }
    };
    if (!isPushed) {
        return /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsx(IconButton, {
                variant: "text",
                onClick: function() {
                    return pushNav(true);
                },
                children: /*#__PURE__*/ _jsx(CogIcon, {})
            })
        });
    }
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsxs(SocialEntry, {
            children: [
                /*#__PURE__*/ _jsx(AddLinks, {
                    children: socialsMore === null || socialsMore === void 0 ? void 0 : socialsMore.map(function(social) {
                        return /*#__PURE__*/ _jsx(Flex, {
                            mb: social.id === "Docs" ? "6px" : "3px",
                            mr: "24px",
                            alignItems: "center",
                            height: 30,
                            children: /*#__PURE__*/ _jsxs(Button, {
                                onClick: function() {
                                    return onClickWalletMenu(social.id);
                                },
                                style: {
                                    background: "transparent",
                                    padding: 0,
                                    border: 0
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: social.imgUrl,
                                        width: social.id === "Docs" ? 14 : 18,
                                        height: social.id === "Docs" ? 14 : 18,
                                        alt: "logo",
                                        style: {
                                            marginRight: social.id === "Docs" ? "6px" : "4px",
                                            marginLeft: social.id === "Docs" ? "4px" : "2px"
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(IconLabel, {
                                        children: t(social.label)
                                    })
                                ]
                            })
                        }, social.label);
                    })
                }),
                /*#__PURE__*/ _jsx(SocialLinks, {})
            ]
        })
    });
};
export default PanelFooter;
